import React from 'react';
import { observer } from 'mobx-react-lite';
import { Window, WindowHeader } from '../overlays';
import { Button } from '../input';
import { ToggleCliprGptWindowState } from './toggleCliprGptWindowState';

type Props = {
  model: ToggleCliprGptWindowState;
  visible?: boolean;
};

export const ToggleCliprGptWindow = observer(({ model, visible }: Props) => {
  return (
    <Window
      model={model.window}
      visible={visible}
      isLoading={model.isLoading}>
      <WindowHeader model={model.window} title={model.header} />

      <hr />

      <div className="window-content">
        <p className="p-bold">
          {model.description}
        </p>
      </div>

      <hr />

      <footer className="window-footer">
        <div className="btn-group right">
          <Button
            className="primary btn-outline medium"
            label="Cancel"
            onClick={() => model.close()}
          />
          <Button
            className="red medium"
            label={model.button}
            onClick={() => model.submit()}
          />
        </div>
      </footer>
    </Window>
  );
});
